// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/zap.js';

import { paths } from '../generated/zap';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('zap', Original, paths);
